(function () {
  'use strict';
  angular.module('neo.config', [])
.constant('EnvironmentConfig', {'API':'http://localhost:7070/neo-api/','whiteListedDomains':['localhost']});
 
})();